import { useMemo } from 'react';
import {
  type BaseChainflipAsset,
  type AnyChainflipAsset,
  chainflipAssets,
  type AnyBaseChainflipAsset,
  isLegacyChainflipAsset,
  type ChainflipAsset,
} from '@chainflip/utils/chainflip';
import { allSupportedAssets } from '@/shared/graphql/cache/assets';
import { useGqlQuery } from '@/shared/hooks/useGqlQuery';
import { compareAssets } from '@/shared/utils/chainflip';

export default function useSupportedAssets(kind?: 'all'): ChainflipAsset[];
export default function useSupportedAssets(
  kind: 'all',
  includeDeprecated?: true,
): AnyChainflipAsset[];
export default function useSupportedAssets(kind: 'base'): BaseChainflipAsset[];
export default function useSupportedAssets(
  kind: 'base',
  includeDeprecated?: true,
): AnyBaseChainflipAsset[];
export default function useSupportedAssets(
  kind: 'all' | 'base' = 'all',
  includeDeprecated = false,
): AnyChainflipAsset[] {
  const { data } = useGqlQuery(allSupportedAssets, {
    context: { clientName: 'statechainCache' },
    select: (result) =>
      (result.assets!.nodes.map((a) => a.id) as AnyChainflipAsset[]).sort(compareAssets),
    staleTime: 60_000,
  });

  return useMemo(() => {
    const all = kind === 'all';
    const assets = data ?? chainflipAssets;
    return assets.filter((asset) => {
      if (all) return includeDeprecated || !isLegacyChainflipAsset(asset);

      return asset !== 'Usdc' && (includeDeprecated || !isLegacyChainflipAsset(asset));
    });
  }, [data, kind, includeDeprecated]);
}
